// Compile history store for adaptive main-thread vs worker execution.
// It keeps recent source timings so auto mode can react to real runtime cost.
export type { LuisCompileHistoryEntry } from './types'
import type { LuisCompileHistoryEntry } from './types'

const historyBySourceId = new Map<string, LuisCompileHistoryEntry>()

// Read last compile history entry for one stable source id.
export function getCompileHistory(sourceId: string): LuisCompileHistoryEntry | undefined {
  // Return stored compile history entry when available.
  return historyBySourceId.get(sourceId)
}

// Save latest compile timing and execution mode for one source id.
export function setCompileHistory(sourceId: string, entry: LuisCompileHistoryEntry): void {
  const previous = historyBySourceId.get(sourceId)
  // Store first timing sample directly for one new runtime source id.
  if (!previous) {
    historyBySourceId.set(sourceId, { ...entry, sampleCount: 1 })
    // Return after storing first sample for this source id.
    return
  } else {
    // Continue rolling compile timing smoothing for repeated source builds.
  }

  const nextSampleCount = Math.min((previous.sampleCount ?? 1) + 1, 8)
  const smoothedDurationMs = previous.durationMs * 0.65 + entry.durationMs * 0.35
  // Save smoothed history so auto execution reacts to recent real cost.
  historyBySourceId.set(sourceId, {
    durationMs: smoothedDurationMs,
    execution: entry.execution,
    sampleCount: nextSampleCount,
  })
}
